import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/lib/auth";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Handles the /#session_id=... fragment Emergent Auth lands the user on.
 * Exchanges it for a persistent session cookie, then redirects to `/` (or
 * a stored returnTo).
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS —
 * THIS BREAKS THE AUTH.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [error, setError] = useState("");
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const r = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        await refresh();
        // Strip the fragment and go home. If we stashed a returnTo path, use it.
        const returnTo = sessionStorage.getItem("fb_return_to") || "/";
        sessionStorage.removeItem("fb_return_to");
        window.history.replaceState({}, "", returnTo);
        navigate(returnTo, { replace: true, state: { user: r.data.user } });
      } catch (e) {
        setError("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/", { replace: true }), 2500);
      }
    })();
  }, [navigate, refresh]);

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black text-white"
      data-testid="auth-callback"
    >
      <div className="font-heading text-2xl tracking-widest uppercase">
        {error || "Signing you in…"}
      </div>
    </div>
  );
}
